// extracted by mini-css-extract-plugin
export var infoRow = "_ol-2";
export var labelContainer = "_ol-0";
export var rightInfo = "_ol-1";